(function () {
  function isOvsClientFilterInput(element) {
    if (!(element instanceof HTMLInputElement)) {
      return false;
    }

    return [...element.classList].some((name) => name.startsWith('ovs-') && name.endsWith('-input'));
  }

  function blockDawnFacetSubmit(event) {
    if (!isOvsClientFilterInput(event.target)) {
      return;
    }

    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  document.addEventListener('input', blockDawnFacetSubmit, true);

  const drawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
  if (!drawer) {
    return;
  }

  const mainDetails = drawer.querySelector(':scope > details');
  if (!mainDetails) {
    return;
  }

  function isOvsDrawerFilterDetails(details) {
    return (
      details instanceof HTMLDetailsElement &&
      details.closest('#FacetsWrapperMobile') &&
      details.classList.contains('facets__disclosure-vertical')
    );
  }

  function keepOvsDrawerFiltersExpanded() {
    drawer.querySelectorAll('#FacetsWrapperMobile details.facets__disclosure-vertical').forEach((details) => {
      details.setAttribute('open', '');
      details.classList.remove('menu-opening');
    });
  }

  drawer.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest('summary');
      if (!summary || summary.parentElement === mainDetails) {
        return;
      }

      const details = summary.parentElement;
      if (!isOvsDrawerFilterDetails(details)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      details.setAttribute('open', '');
    },
    true
  );

  mainDetails.addEventListener('toggle', () => {
    if (mainDetails.open) {
      keepOvsDrawerFiltersExpanded();
    }
  });

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!isOvsClientFilterInput(input)) {
        return;
      }

      const inputClass = [...input.classList].find((name) => name.startsWith('ovs-') && name.endsWith('-input'));
      if (!inputClass) {
        return;
      }

      document.querySelectorAll(`input.${inputClass}[value="${CSS.escape(input.value)}"]`).forEach((mirror) => {
        mirror.checked = input.checked;
      });
    },
    true,
  );

  keepOvsDrawerFiltersExpanded();
})();
